import { Grid } from "@mui/material";
import React from "react";
import stick from "./../../images/stick.png"
import commingsoon from "./../../images/commingsoon.png"
const NFTCards = () => {
    return(
        <Grid
            xs={12}
            sm={6}
            md={4}
            lg={3}
            className="px-sm-2 px-lg-4 pl-md-4"
        >
            <div 
                className="MS---dapp_form MS---dapp_card text-center mt-4 mt-lg-0 px-4 px-sm-3 pt-4 mx-auto position-relative" 
                style={{maxWidth: 200, minHeight: 550}}>
                <div className="MS--comingsoon">
                    <img src={commingsoon} style={{height: '100%', width: 'auto'}} />
                </div>
                {/* <h2 className="mb-0 mt-3" style={{color: '#69DB59', fontWeight: 600}}>King</h2>
                <div className="d-flex justify-content-between mx-auto mt-4" style={{maxWidth: 220}}>
                    <span className="d-inline-block">
                        Force
                    </span>
                    <div className="d-flex MS---NFT-Loader">
                        <span className="a"></span>
                        <span className="a"></span>
                        <span className="a"></span>
                        <span className="a"></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="d-flex justify-content-between mx-auto mt-2" style={{maxWidth: 220}}>
                    <span className="d-inline-block">
                        Aim
                    </span>
                    <div className="d-flex MS---NFT-Loader">
                        <span className="a"></span>
                        <span className="a"></span>
                        <span className="a"></span>
                        <span className="a"></span>
                        <span className="a"></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="d-flex justify-content-between mx-auto mt-2" style={{maxWidth: 220}}>
                    <span className="d-inline-block">
                        Spin
                    </span>
                    <div className="d-flex MS---NFT-Loader">
                        <span className="a"></span>
                        <span className="a"></span>
                        <span className="a"></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <img src={stick} className="img-fluid mt-1 mr-2" /> */}
            </div>
            <button className="disable btn mt-4 mb-5" target="_blank" disabled>
                Buy NFT
                <div class="bg"></div>
                <div class="disable"></div>
            </button>
        </Grid>
    )
}
export default NFTCards;